export enum FeatureFlags {
  MAINTENANCE_MODE_ENABLED = 'maintenance_mode_enabled',
  NEW_GTM_DEBUG_MODE = 'feature_new_gtm_debug_mode',
  WINTER_PROMO_THEME = 'feature_winter_promo_theme',
  OCTOBER_PROMO_THEME = 'feature_october_promo_theme',
  BLACK_FRIDAY_PROMO = 'feature_black_friday',
  BLACK_SEPTEMBER_PROMO = 'feature_black_september',
  BLACK_APRIL_PROMO = 'feature_black_april',
  SUMMER_DEALS_PROMO = 'feature_summer_deals',
  VALENTINE_PROMO = 'feature_valentine_theme',
  SPRING_THEME = 'feature_spring_theme',
  EASTER_THEME = 'feature_easter_theme',
  MAY_THEME = 'feature_may_theme',
  SUMMER_THEME = 'feature_summer_theme',
  NEW_MAIN_BANNER = 'feature_new_main_banner',
  B2B_PAGE = 'feature_b2b_page',
  NEW_YEAR = 'feature_new-year',
  NEW_VOUCHER_PROCESS = 'feature_new-voucher-process',
  DIXA_CHAT = 'feature_dixa_chat',
  DEALS_OF_THE_DAY_WIDGET = 'feature_deals_of_the_day_widget',
  STATIC_EXIT_INTENT_POPUP = 'feature_static_exit_intent_popup',
  IFRAME_OFFER_CARD_PAGE = 'feature_iframe_offer_card_page',
}
